import React, { useCallback, useEffect, useState } from 'react'
import { IoMdRefresh } from "react-icons/io";
import {
  getCoreRowModel,
  useReactTable,
  getPaginationRowModel,
} from '@tanstack/react-table'
import ModalAssignment from 'components/Planning/Modal/ModalAssignment';
import ModuleLayout from 'layout/ModuleLayout';
import assignmenColumns from 'utils/columns/Assignment';
import { useTranslation } from "react-i18next";
import { getAppointments, getDates, getDrivers, getServices, getTrucks } from 'actions/Assignment';
import { useSelector, useDispatch } from 'react-redux';
import DataTable from 'components/DataTable';
import { resetState, setAppointmentsSelected, resetStateByFilter } from 'redux/assignment.slice';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const PlanningAssiggnment2 = () => {
  const dispatch = useDispatch();
  const { appointments, appointmentsSelected, services, dates } = useSelector((state) => state.assignment);
  const { currentProject } = useSelector((state) => state.auth);
  const [t] = useTranslation("planning");
  const [isOpen, setIsOpen] = useState(false);
  const [formFilter, setFormFilter] = useState({
    idService: 0,
    date: "",
  });

  useEffect(() => {
    if (formFilter.idService !== 0) { 
      dispatch(getDates({ idProject: currentProject.id, idService: formFilter.idService }));
      dispatch(getDrivers(formFilter.idService));
    }
  }, [dispatch, formFilter.idService, currentProject.id]);


  const getAppointmentsFn = useCallback(async () => {
    if (formFilter.idService !== 0 && formFilter?.date !== "") { 
      dispatch(getAppointments({ idProject: currentProject.id, idService: formFilter.idService, date: formFilter.date }));
    }
  }, [dispatch, currentProject.id, formFilter]);

  useEffect(() => {
    getAppointmentsFn();
  }, [getAppointmentsFn]);

  useEffect(() => {
    if (currentProject && currentProject?.id) { 
      dispatch(getServices(currentProject.id));
      dispatch(getTrucks(currentProject.id));
      dispatch(resetState());
    }
  }, [dispatch, currentProject]);


  const handleUpdateAppointments = (trip, action) => {
    const updateAppointments = action === 'add' ? [...appointmentsSelected, trip] : appointmentsSelected.filter(appointment => appointment.id !== trip.id);
    dispatch(setAppointmentsSelected(updateAppointments));
  }

  const table = useReactTable({
    data: appointments,
    columns: assignmenColumns(() => setIsOpen(true), t, appointmentsSelected, handleUpdateAppointments),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const handleDateChange = (date) => {
    const fechaFormateada = date.toISOString().split("T")[0];
    setFormFilter({...formFilter, date: fechaFormateada })
  };

  const handleReset = () => {
    setFormFilter({
      idService: 0,
      date: "",
    });
    dispatch(resetStateByFilter());
  }

  return (
    <ModuleLayout tittle={t("planAssignment.title")}>
      <div
        className="w-[90%] lg:h-16 h-10 flex flex-col lg:flex-row items-center justify-between bg-[#464646] text-white rounded-xl px-4 mx-auto shadow-md relative"
      >
        <div className='lg:text-3xl'>
          <h2 className='lg:text-3xl'>
            {t("planAssignment.subtitle")}
          </h2>
        </div>
        <div className='text-white flex flex-row space-x-2'>
          <div className='flex flex-col'>
            {t("planAssignment.service")} :
            <select 
              value={formFilter.idService} 
              onChange={({target})=>{
                setFormFilter({...formFilter, idService: target.value})
              }} 
              className='rounded-md h-8 bg-[#e1e1e1]'
            >
              <option value={0}>Selecciona una opción</option>
              {services.map((service) => (
                <option key={service.key} value={service.key}>{service.label}</option>
              ))}
            </select>
          </div>
          <div className='flex flex-col'>
            {t("planAssignment.date")} :
              <DatePicker
                //selected={fechaSeleccionada}
                value={formFilter.date}
                onChange={(date) => handleDateChange(date)}
                includeDates={dates}
                placeholderText="Selecciona una fecha"
                dateFormat="yyyy-MM-dd"
                className='rounded-md h-8 bg-[#e1e1e1] text-white'
                locale={"es"} 
              />
          </div>
          <div className='flex items-end text-2xl'>
            <div className='w-10 h-10 flex justify-center items-center cursor-pointer bg-[#929292] rounded-full hover:bg-white hover:text-[#929292]'>
              <IoMdRefresh onClick={handleReset}/>
            </div>
          </div>
        </div>
      </div>
      <DataTable table={table} w='90%' />
      <ModalAssignment 
        isOpen={isOpen} 
        onClose={() => setIsOpen(false)} 
        getAppointmentsFn={getAppointmentsFn}
      />
    </ModuleLayout>
  )
}

export default PlanningAssiggnment2